<template>
  <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" class="sidebar left">
    <div class="grid-content bg-purple">
      <LoginControl class="Pclogin"></LoginControl>
      <div class="allbox t-center" style="padding: 15px 0">
        <div>欢迎关注期刊微信公众号，<br />及时获取稿件通知与期刊资讯</div>
        <img src="../../assets/images/ewm1.gif" alt="" />
      </div>
      <div class="allbox mt15">
        <div class="title_all">
          <div class="title_left">下载中心</div>
          <div class="title_more">
            <router-link to="/DocumentList?ColumnId=6"></router-link>
          </div>
        </div>
        <Control :params="{ ColumnId: 6, PageSize: 10 }"></Control>
      </div>
      <div class="leftlist mt15">
        <div class="mt15 listinfo">
          <div v-html="Info"></div>
        </div>
      </div>
    </div>
  </el-col>
</template>

<script>
import Control from './page/Control'
import Ranking from './page/Ranking'
import FrLinks from './page/FrLinks'
import LoginControl from '../../components/LoginControl'
export default {
  name: 'Sidebar',
  data() {
    return {
      activeName: 'first',
      type: 1,
      activeNamea: 'firsta',
      activeNameb: 'firstb',
      slqk: '',
      data: {},
      Volume: '',
      newYears: '',
      newMonth: '',
      SetItem: {},
      ISSN: '',
      CN: '',
      imgUrl: '',
      YearIssue_NoTtitle: '',
      recomList: [],
      Info: '',
    }
  },
  created() {
    this.getProfiles() //期刊信息
  },
  components: { Control, FrLinks, Ranking, LoginControl },
  mounted() {
    if (this.$route.path == '/FixedBody') {
      this.activeName = 'first'
    } else if (this.$route.path === '/Authorgarden') {
      this.activeName = 'two'
    }
    if (sessionStorage.getItem('slqk')) {
      this.slqk = JSON.parse(sessionStorage.getItem('slqk'))
    } else {
      let params = [80, 8, 9, 1400]
      this.$store.dispatch('_getHeader', params).then((res) => {
        res.data.Data.map((item) => {
          if (item.ItemId == 1400) {
            this.slqk = item.Body
            sessionStorage.setItem('slqk', JSON.stringify(item.Body))
          }
        })
      })
    }
    if (sessionStorage.getItem('newYears')) {
      this.data = JSON.parse(sessionStorage.getItem('newYears'))
      this.Volume = this.data.Volume
      this.newYears = this.data.newYears

      this.imgUrl = this.data.CoverGUID + this.data.CoverSuffix
      this.YearIssue_NoTtitle = this.data.YearIssue_NoTtitle
    } else {
      this.$store.dispatch('_getYear', { Id: -1 }).then((res) => {
        if (res.data.Data) {
          this.newListTitle = res.data.Data.YearIssue_NoTtitle
          let data = {
            newYears: res.data.Data.Publish_Date,
            Volume: res.data.Data.Volume,
            CoverGUID: res.data.Data.CoverGUID,
            CoverSuffix: res.data.Data.CoverSuffix,
            YearIssue_NoTtitle: res.data.Data.YearIssue_NoTtitle,
          }
          this.Volume = res.data.Data.Volume
          this.newYears = res.data.Data.Publish_Date
          this.imgUrl = res.data.Data.CoverGUID + res.data.Data.CoverSuffix
          this.YearIssue_NoTtitle = res.data.Data.YearIssue_NoTtitle
          sessionStorage.setItem('newYears', JSON.stringify(data))
        }
      })
    }
    if (sessionStorage.getItem('SetItem')) {
      let SetItem = JSON.parse(sessionStorage.getItem('SetItem'))
      SetItem.map((item) => {
        if (item.SetItemID == 5000) {
          this.ISSN = item.Item_Value
        }
        if (item.SetItemID == 5010) {
          this.CN = item.Item_Value
        }
      })
    } else {
      let params = [
        1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960,
        4554,
      ]
      this.$store.dispatch('_getSet', params).then((res) => {
        this.SetItem = res.data.Data
        sessionStorage.setItem('SetItem', JSON.stringify(res.data.Data))
        this.SetItem.map((item) => {
          if (item.SetItemID == 5000) {
            this.ISSN = item.Item_Value
          }
          if (item.SetItemID == 5010) {
            this.CN = item.Item_Value
          }
        })
      })
    }
  },
  methods: {
    getProfiles() {
      let data = [12]
      this.$store.dispatch('_getHeader', data).then((res) => {
        if (res.data.IsSuccess) {
          if (res.data.Data.length > 0) {
            this.Info = res.data.Data[0].Body
          }
        }
      })
    },
    godigese(ids) {
      this.$newOpen('/#/digest?ArticleID=' + ids)
    },
    goExport(ids) {
      this.$newOpen('/#/Export?ids=' + ids)
    },
    pdf(i, size, guid) {
      if (size <= 0) {
        alert('文件不存在')
        return
      }
      this.$store.dispatch('_getPDF', { Id: guid }).then((Result) => {
        window.location.href = Result.request.responseURL
      })
    },
    goHtml(url) {
      window.open(url, '_blank')
    },
    oniscode(num) {
      this.centerDialogVisible = true
      this.codeId = num
    },
    handleClick(tab, event) {},
    handleClicka(tab, event) {},
  },
}
</script>

<style>
.qktext p {
  line-height: 24px;
}
.qkjjtext img {
  height: 210px;
  display: inline-block;
}
</style>
